export default {
    customers: state => state.customers,
    activeCustomer: state => state.activeCustomer,
    manageCustomerDialog: state => state.manageCustomerDialog,
    deleteCustomerDialog: state => state.deleteCustomerDialog
}
